module.exports = __webpack_public_path__ + "img/cx_icon_04.png";